
































































































































import CommonIconBtn from '@/components/Common/CommonIconBtn.vue';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({
  name: 'studentQuerySearchDisplay',
  components: {
    CommonIconBtn,
  }
})
export default class extends Vue {
  @Prop({ required: true }) public data!: any;
  @Prop({ required: false }) public show!: boolean;
  @Prop({ required: false }) public updateData!: boolean; // 是否更新搜索条件展示数据

  get showSearchDisplay() {
    const data = this.displayData;
    return this.show && (data.keyWord|| data.fkAreaCountryIdName || data.applyAreaCountryIdName
    || data.fkInstitutionIdName|| data.fkMajorLevelIdName || data.fkInstitutionCourseIdName
    || data.changeStep.join() || data.openTimeStart || data.openTimeEnd || data.submitStartTime
    || data.submitEndTime || data.createStartTime || data.createEndTime || data.gmtCreateUser.join());
    // || data.statusBeginTime || data.statusEndTime
  }

  public displayData: any = {
    keyWord: '',
    fkAreaCountryIdName: '',
    applyAreaCountryIdName: '',
    fkInstitutionIdName: '',
    fkMajorLevelIdName: '',
    fkInstitutionCourseIdName: '',
    openTimeStart: '',
    openTimeEnd: '',
    submitStartTime: '',
    submitEndTime: '',
    createStartTime: '',
    createEndTime: '',
    changeStep: [],
    gmtCreateUser: [],
    openTimeRange: [],
    submitTimeRange: [],
    createTimeRange: [],
  };

  @Watch('updateData')
  public updateDisplayData(val: boolean) {
    if (val) {
      this.displayData = Object.assign({}, this.data);
    }
  }

  public clear(key: string) {
    if (['changeStep', 'gmtCreateUser'].includes(key)) {
      this.displayData[key] = [];
    } else {
      this.displayData[key] = '';
    }
    this.$emit('clear-search', key);
  }
}
